var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-10 pr-10"},[(!_vm.showLoginOnly)?_c('div',{staticClass:"pt-30"},[(_vm.placeholderFeatureActive)?_c('h3',{staticClass:"title is-3 has-text-centered"},[_vm._v("\n      "+_vm._s(_vm.$t('nenaFeatureIntro'))+"\n    ")]):_c('h3',{staticClass:"title is-3 has-text-centered"},[_vm._v("\n      "+_vm._s(_vm.artist.nickname)+" "+_vm._s(_vm.$t('offerAccess', {
        nickname:
          _vm.artist.nickname
      }))+"\n    ")]),_vm._v(" "),(!_vm.placeholderFeatureActive)?_c('h5',{staticClass:"title is-5 has-text-centered"},[_vm._v("\n      Let's make it happen!\n    ")]):_vm._e(),_vm._v(" "),_c('select-purchasable',{attrs:{"post":_vm.user.singlePost,"item":_vm.itemData,"placeholderFeatureActive":_vm.placeholderFeatureActive},on:{"selected":_vm.purchasableSelected}}),_vm._v(" "),(_vm.user.singlePost.limitToFollowers && !_vm.artist.followed)?_c('div',{staticClass:"pt-20"},[(_vm.placeholderFeatureActive)?_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('nenaFeatureOfferAccessToFollowers'))+"\n      ")]):_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('offerAccessToFollowers', { nickname: _vm.artist.nickname }))+"\n      ")]),_vm._v(" "),_c('followButton',{staticClass:"mt-5",attrs:{"user":_vm.user,"fullWidth":false,"withIcon":false,"singlePost":true}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showLoginOnly && !_vm.isAuthenticated)?_c('div',{staticClass:"pt-30"},[_c('socialLogin',{attrs:{"params":{
        isWizard: true,
        onPost: true,
        returnRouteObject: {
          route: {
            name: `id-post-slug-postId___${_vm.$i18n.locale}`,
            params: {
              id: _vm.artist.urlAlias,
              postId: _vm.user.singlePost.id,
              slug: _vm.urlSlug(_vm.user.singlePost.title),
              type: _vm.selectedPurchasable ? _vm.selectedPurchasable.type : null,
              item: _vm.selectedPurchasable ? _vm.selectedPurchasable.item._id : null
            },
            query: {
              refresh: true
            }
          },
          locales: _vm.$root.$i18n['locales'],
          locale: _vm.$i18n.locale
        }
      }},on:{"cancelled":_vm.emitCancelled,"registration":_vm.setSocialRegistration,"logged":_vm.loggedIn}}),_vm._v(" "),(!_vm.socialRegistration)?_c('div',[_c('div',{staticClass:"is-divider",attrs:{"data-content":_vm.$t('or')}}),_vm._v(" "),_c('login',{attrs:{"params":{
          isWizard: true,
          onPost: true,
          returnRouteObject: {
            route: {
              name: `id-post-slug-postId___${_vm.$i18n.locale}`,
              params: {
                id: _vm.artist.urlAlias,
                postId: _vm.user.singlePost.id,
                slug: _vm.urlSlug(_vm.user.singlePost.title),
                type: _vm.selectedPurchasable ? _vm.selectedPurchasable.type : null,
                item: _vm.selectedPurchasable ? _vm.selectedPurchasable.item._id : null
              },
              query: {
                refresh: true
              }
            },
            locales: _vm.$root.$i18n['locales'],
            locale: _vm.$i18n.locale
          }
        }},on:{"logged":_vm.loggedIn,"viewChanged":_vm.loginViewChanged}})],1):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }